module.exports = __webpack_public_path__ + "static/img/red2.eb865ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/4/red2.png
// module id = DKiv
// module chunks = 0